import React from 'react';
import { Modal } from 'react-bootstrap';
export default function SelectMountGrommetStep4({
  pageLanguage,
  modals,
  modalHandleClose,
  t,
}) {
  return (
   <Modal
   dialogClassName={`noInsideUnderstand_modal mediumSizeModal ${
     pageLanguage === "fa" ? "font_farsi" : "font_en"
   }`}
   show={modals["noInsideUnderstand"] === undefined ? false : modals["noInsideUnderstand"]}
   onHide={() => modalHandleClose("noInsideUnderstand")}
 >
   <Modal.Header closeButton></Modal.Header>
   <Modal.Body>
     <p>{t("modal_select_mount_grommet")}</p>
     <div className=" text_center">
       <button
         className=" btn btn-new-dark"
         onClick={() => modalHandleClose("noInsideUnderstand")}
       >
         {t("CONTINUE")}
       </button>
     </div>
   </Modal.Body>
 </Modal>
  )
}
